import { getReferenceOffsets, setAllStyles } from './utils';
import { arrow, flip, preventOverflow, shift, initData } from './modifiers';
export class Positioning {
    position(hostElement, targetElement, round = true) {
        return this.offset(hostElement, targetElement, false);
    }
    offset(hostElement, targetElement, round = true) {
        return getReferenceOffsets(targetElement, hostElement);
    }
    positionElements(hostElement, targetElement, position, appendToBody) {
        const chainOfModifiers = [flip, shift, preventOverflow, arrow];
        return chainOfModifiers.reduce((modifiedData, modifier) => modifier(modifiedData), initData(targetElement, hostElement, position));
    }
}
const positionService = new Positioning();
export function positionElements(hostElement, targetElement, placement, appendToBody, renderer) {
    const data = positionService.positionElements(hostElement, targetElement, placement, appendToBody);
    setAllStyles(data, renderer);
}
//# sourceMappingURL=ng-positioning.js.map